<div>
  <mat-toolbar class="page-header">
    <div class="menu-container">
      <div class="pg-title">{{ "company.company" | translate }}</div>
    </div>
  </mat-toolbar>

  <div class="content-container">
    <div class="filter-btn-flex">
      <div class="filter">
        <mat-form-field
          appearance="outline"
          class="pg-filter filter__search"
          >
          <input
            matInput
            [placeholder]="'dashboard.searchHere' | translate"
            autocomplete="off"
            [(ngModel)]="searchText"
            (ngModelChange)="searchChanged()"
            />
            @if (searchText) {
              <button
                mat-icon-button
                matSuffix
                class="clear-field-btn"
                (click)="resetTextFilter()"
                >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="pg-filter"
            >
            <mat-select placeholder="Status" [(ngModel)]="selectedStatus">
              <mat-option [value]="'all'" (click)="setStatus('all')">{{
                "dashboard.allStatus" | translate
              }}</mat-option>
              <mat-option [value]="'active'" (click)="setStatus('active')">{{
                "auth.active" | translate
              }}</mat-option>
              <mat-option [value]="'inActive'" (click)="setStatus('inActive')">{{
                "auth.deactivated" | translate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <button
          mat-flat-button
          (click)="openCreateCompanyDialog()"
          class="secondary"
          [disabled]="!isAccessAllowed(functionalAccess.createCompany)"
          >
          {{ "common.create" | translate }}
        </button>
      </div>
      <div class="isScrollable">
        <div class="table-wrapper">
          @if (isAccessAllowed(functionalAccess.listing)) {
            <table
              mat-table
              [dataSource]="list"
              matSort
              matSortActive="createdDate"
              matSortDisableClear
              matSortDirection="desc"
              (matSortChange)="sortChange($event)"
              >
              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "company.creationDate" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ (element?.createdDate | date : "dd MMM yyyy") || "-" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "company.createdBy" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.createdBy || "-" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "company.companyName" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.name || "-" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="ssmid">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "company.ssmID" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.ssmid || "-" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="paymentMethod">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "company.paymentMethod" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.paymentMethod || "-" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                  <div>
                    @switch (element.status) {
                      @case ('Active') {
                        <span class="cover-label green">{{
                          "auth.active" | translate
                        }}</span>
                      }
                      @case ('Inactive') {
                        <span class="cover-label red">{{
                          "auth.deactivated" | translate
                        }}</span>
                      }
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  @if (element?.status == 'Active') {
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="menuActionButton"
                      [matMenuTriggerData]="{ data: element }"
                      >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                  @if (element?.status == 'Inactive') {
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="menuActionButtonDeactivated"
                      [matMenuTriggerData]="{ data: element }"
                      >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr *matNoDataRow>
                <td class="mat-cell" colspan="9999">
                  @if (!isLoading && list.length === 0) {
                    <app-empty-record
                      [disableSubTitle]="true"
                    ></app-empty-record>
                  }
                  @if (isLoading) {
                    <ngx-skeleton-loader
                      count="3"
								[theme]="{
									height: '40px',
									'animation-duration': '1s'
								}"
                    ></ngx-skeleton-loader>
                  }
                </td>
              </tr>
            </table>
          }
        </div>
        <mat-paginator
          #paginator
          [pageSizeOptions]="[50, 100, 150]"
          [pageSize]="limit"
          [length]="length"
          (page)="pageChange($event)"
          aria-label="Select page of companies"
        ></mat-paginator>
      </div>
    </div>
  </div>

  <mat-menu #menuActionButton="matMenu">
    <ng-template matMenuContent let-data="data">
      @if (isAccessAllowed(functionalAccess.deactivateCompany)) {
        <button
          mat-menu-item
          class="color-red"
          (click)="deactivateCompany(data)"
          >
          {{ "company.deactivate" | translate }}
        </button>
      }
      @if (isAccessAllowed(functionalAccess.updateCompany)) {
        <button
          mat-menu-item
          (click)="openUpdateCompanyDialog(data)"
          >
          {{ "common.edit" | translate }}
        </button>
      }
    </ng-template>
  </mat-menu>

  <mat-menu #menuActionButtonDeactivated="matMenu">
    <ng-template matMenuContent let-data="data">
      <button
        mat-menu-item
        (click)="reactivateCompany(data?.id)"
        >
        {{ "company.activate" | translate }}
      </button>
    </ng-template>
  </mat-menu>
